class MemoryStatsModel {
  id: string;
  memory: number;
}

export class MorphStatsModel extends MemoryStatsModel {
  verts: number;
}

export class GeoStatsModel extends MemoryStatsModel {
  tris: number;
  verts: number;
}

export class MemoryStatsSummaryModel<T extends MemoryStatsModel> {
  [key: string]: T;
}
